export const pakVsAusLeaderBoardData = [
  {
    _id: '624c4bd6ef7a36001f872b3f',
    winning: 7500000,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '624c4bd2ef7a36001f872b3e',
    captainId: '62487296bc54653691c42edc',
    viceCaptainId: '62487296bc54653691c42ed8',
    score: 412.5,
    verifiedScore: 412.5,
    username: 'Kamal',
    players: [
      {
        playerId: '62487296bc54653691c42f12',
        rating: 9.5,
        teamId: 13,
        role: 'wk'
      },
      {
        playerId: '62487296bc54653691c42ecf',
        rating: 8.5,
        teamId: 5,
        role: 'wk'
      },
      {
        playerId: '62487296bc54653691c42ed4',
        rating: 9.5,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42edc',
        rating: 9,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42ed8',
        rating: 9,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42f23',
        rating: 9,
        teamId: 13,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42ee8',
        rating: 9.5,
        teamId: 5,
        role: 'all'
      },
      {
        playerId: '62487296bc54653691c42eee',
        rating: 9,
        teamId: 5,
        role: 'all'
      },
      {
        playerId: '62487296bc54653691c42f47',
        rating: 9,
        teamId: 13,
        role: 'bowl'
      },
      {
        playerId: '62487296bc54653691c42f4f',
        rating: 9,
        teamId: 13,
        role: 'bowl'
      },
      {
        playerId: '62487296bc54653691c42efc',
        rating: 8.5,
        teamId: 5,
        role: 'bowl'
      }
    ]
  }
];

export const wiVsEngLeaderBoardData = [
  {
    _id: '622c859eff867e001dbb44f6',
    winning: 40000,
    rank: 1,
    tenant: 'dev',
    userId: '5fd09165583ada578d664a9c',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '622c8585ff867e001dbb44f5',
    captainId: '622ae1b082f394e16728dde5',
    viceCaptainId: '622ae1b082f394e16728ddfb',
    score: 1343,
    verifiedScore: 1343,
    username: 'The11',
    players: [
      {
        playerId: '622ae1b082f394e16728de15',
        rating: 9.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde4',
        rating: 8.5,
        teamId: 17,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde5',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dde9',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de23',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2a',
        rating: 10,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728ddfb',
        rating: 8.5,
        teamId: 17,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728de03',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de2e',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de0a',
        rating: 8.5,
        teamId: 17,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '622c93e9ff867e001dbb4644',
    winning: 20000,
    rank: 2,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Verma',
    teamNumber: 2,
    matchTeamId: '622c855eff867e001dbb44f1',
    captainId: '622ae1b082f394e16728de2a',
    viceCaptainId: '622ae1b082f394e16728dded',
    score: 1324,
    verifiedScore: 1324,
    username: 'Kamal',
    players: [
      {
        playerId: '622ae1b082f394e16728de15',
        rating: 9.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde4',
        rating: 8.5,
        teamId: 17,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde5',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dde9',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de23',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2a',
        rating: 10,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728ddfb',
        rating: 8.5,
        teamId: 17,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728de2e',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de07',
        rating: 8.5,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de31',
        rating: 8.5,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '622c99b1ff867e001dbb4658',
    winning: 19000,
    rank: 3,
    tenant: 'dev',
    userId: '610b838e1545db0010b603fe',
    firstname: 'Alpha',
    lastname: 'Male',
    teamNumber: 1,
    matchTeamId: '622c8275ff867e001dbb445d',
    captainId: '622ae1b082f394e16728dded',
    viceCaptainId: '622ae1b082f394e16728de23',
    score: 1272,
    verifiedScore: 1272,
    username: 'BoomXhakaLaca',
    players: [
      {
        teamId: 490,
        role: 'wk',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de1b'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728dde5'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728dde9'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728de23'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728dded'
      },
      {
        teamId: 490,
        role: 'all',
        rating: 10,
        playerId: '622ae1b082f394e16728de2a'
      },
      {
        teamId: 490,
        role: 'all',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de2c'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de03'
      },
      {
        teamId: 490,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de2e'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de07'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de0a'
      }
    ]
  },
  {
    _id: '622c879fff867e001dbb452a',
    winning: 19000,
    rank: 6,
    tenant: 'dev',
    userId: '5fd09165583ada578d664a9c',
    firstname: null,
    lastname: null,
    teamNumber: 2,
    matchTeamId: '622c8791ff867e001dbb4529',
    captainId: '622ae1b082f394e16728de21',
    viceCaptainId: '622ae1b082f394e16728ddfb',
    score: 1240,
    verifiedScore: 1232,
    username: 'The11',
    players: [
      {
        teamId: 490,
        role: 'wk',
        rating: 9.5,
        playerId: '622ae1b082f394e16728de15'
      },
      {
        teamId: 17,
        role: 'wk',
        rating: 8.5,
        playerId: '622ae1b082f394e16728dde4'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 10,
        playerId: '622ae1b082f394e16728de21'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728de23'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728dded'
      },
      {
        teamId: 490,
        role: 'all',
        rating: 10,
        playerId: '622ae1b082f394e16728de2a'
      },
      {
        teamId: 17,
        role: 'all',
        rating: 8.5,
        playerId: '622ae1b082f394e16728ddfb'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de03'
      },
      {
        teamId: 490,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de2e'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de07'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de0a'
      }
    ]
  },
  {
    _id: '622c87d7ff867e001dbb4550',
    winning: 0,
    rank: 17,
    tenant: 'dev',
    userId: '5fd09365583ada264d664ac0',
    firstname: 'Shubham',
    lastname: 'Srivastava',
    teamNumber: 6,
    matchTeamId: '622c83e7ff867e001dbb4490',
    captainId: '622ae1b082f394e16728de21',
    viceCaptainId: '622ae1b082f394e16728de00',
    score: 1158.5,
    verifiedScore: 1150.5,
    username: 'TRICKSTAR',
    players: [
      {
        playerId: '622ae1b082f394e16728de15',
        rating: 9.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728de21',
        rating: 10,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dde9',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728ddf0',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de26',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2a',
        rating: 10,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728de00',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de03',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de2e',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de0a',
        rating: 8.5,
        teamId: 17,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '622c8371ff867e001dbb4466',
    winning: 0,
    rank: 23,
    tenant: 'dev',
    userId: '5fd09365583ada264d664ac0',
    firstname: 'Shubham',
    lastname: 'Srivastava',
    teamNumber: 1,
    matchTeamId: '622c836dff867e001dbb4464',
    captainId: '622ae1b082f394e16728de23',
    viceCaptainId: '622ae1b082f394e16728de2a',
    score: 1097.5,
    verifiedScore: 1093.5,
    username: 'TRICKSTAR',
    players: [
      {
        teamId: 490,
        role: 'wk',
        rating: 9.5,
        playerId: '622ae1b082f394e16728de15'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 10,
        playerId: '622ae1b082f394e16728de21'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728dde9'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 9,
        playerId: '622ae1b082f394e16728de23'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728dded'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728ddf0'
      },
      {
        teamId: 490,
        role: 'all',
        rating: 10,
        playerId: '622ae1b082f394e16728de2a'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de00'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de03'
      },
      {
        teamId: 490,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de2e'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de07'
      }
    ]
  },
  {
    _id: '622c87d7ff867e001dbb454e',
    winning: 0,
    rank: 21,
    tenant: 'dev',
    userId: '5fd09365583ada264d664ac0',
    firstname: 'Shubham',
    lastname: 'Srivastava',
    teamNumber: 4,
    matchTeamId: '622c83a4ff867e001dbb446e',
    captainId: '622ae1b082f394e16728dded',
    viceCaptainId: '622ae1b082f394e16728de00',
    score: 1142.5,
    verifiedScore: 1138.5,
    username: 'TRICKSTAR',
    players: [
      {
        playerId: '622ae1b082f394e16728dde4',
        rating: 8.5,
        teamId: 17,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728de21',
        rating: 10,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dde9',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728ddf0',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de26',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2a',
        rating: 10,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728de00',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de03',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de2e',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de0a',
        rating: 8.5,
        teamId: 17,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '622c87d7ff867e001dbb4555',
    winning: 0,
    rank: 31,
    tenant: 'dev',
    userId: '5fd09365583ada264d664ac0',
    firstname: 'Shubham',
    lastname: 'Srivastava',
    teamNumber: 11,
    matchTeamId: '622c8692ff867e001dbb44ff',
    captainId: '622ae1b082f394e16728de2e',
    viceCaptainId: '622ae1b082f394e16728de0a',
    score: 903.5,
    verifiedScore: 899.5,
    username: 'TRICKSTAR',
    players: [
      {
        teamId: 490,
        role: 'wk',
        rating: 9.5,
        playerId: '622ae1b082f394e16728de15'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 10,
        playerId: '622ae1b082f394e16728de21'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728dded'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728ddf0'
      },
      {
        teamId: 17,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728ddf6'
      },
      {
        teamId: 490,
        role: 'bat',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de26'
      },
      {
        teamId: 490,
        role: 'all',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de2c'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de00'
      },
      {
        teamId: 490,
        role: 'bowl',
        rating: 9,
        playerId: '622ae1b082f394e16728de2e'
      },
      {
        teamId: 17,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de0a'
      },
      {
        teamId: 490,
        role: 'bowl',
        rating: 8.5,
        playerId: '622ae1b082f394e16728de33'
      }
    ]
  },
  {
    _id: '6230717b5aa9b1001e96e60b',
    winning: 0,
    rank: 42,
    tenant: 'dev',
    userId: '606d741a08ec512c4b83f558',
    firstname: 'Liverpool',
    lastname: 'Anfield',
    teamNumber: 10,
    matchTeamId: '62307164ffd21d001e9c3a46',
    captainId: '622ae1b082f394e16728de15',
    viceCaptainId: '622ae1b082f394e16728de23',
    score: 795,
    verifiedScore: 795,
    username: 'Liverpool2018',
    players: [
      {
        playerId: '622ae1b082f394e16728de15',
        rating: 9.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde4',
        rating: 8.5,
        teamId: 17,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728de1b',
        rating: 8.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728dde9',
        rating: 9,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de23',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728ddf0',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2c',
        rating: 8.5,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728de00',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de03',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de2e',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  }
];

export const saVsEngLeaderBoardData = [
  {
    _id: '63d0fa9a67b0c2001d35fb4a',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: 'Tushar',
    lastname: 'Patil',
    teamNumber: 1,
    matchTeamId: '63d0fa8f67b0c2001d35fb49',
    captainId: '63d0da0f96851a4d7f67e84b',
    viceCaptainId: '63d0da0f96851a4d7f67e852',
    score: 0,
    username: 'tushar0902',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e870',
        rating: 9,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e854',
        rating: 8.5,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d0fbb367b0c2001d35fb4f',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d0fbab67b0c2001d35fb4e',
    captainId: '63d0da0f96851a4d7f67e870',
    viceCaptainId: '63d0da0f96851a4d7f67e84b',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e870',
        rating: 9,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84d',
        rating: 8.5,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e874',
        rating: 8.5,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d1029967b0c2001d35fb5b',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: 'Tushar',
    lastname: 'Patil',
    teamNumber: 2,
    matchTeamId: '63d1028d67b0c2001d35fb5a',
    captainId: '63d0da0f96851a4d7f67e84b',
    viceCaptainId: '63d0da0f96851a4d7f67e85a',
    score: 0,
    username: 'tushar0902',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e870',
        rating: 9,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e854',
        rating: 8.5,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d102f667b0c2001d35fb64',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '638db5e1ae6c46001be9c05d',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '63d101d267b0c2001d35fb54',
    captainId: '63d0da0f96851a4d7f67e876',
    viceCaptainId: '63d0da0f96851a4d7f67e852',
    score: 0,
    username: 'tushar92',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e863',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d102f667b0c2001d35fb65',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '638db5e1ae6c46001be9c05d',
    firstname: null,
    lastname: null,
    teamNumber: 2,
    matchTeamId: '63d102df67b0c2001d35fb5f',
    captainId: '63d0da0f96851a4d7f67e86a',
    viceCaptainId: '63d0da0f96851a4d7f67e852',
    score: 0,
    username: 'tushar92',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e863',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d102f667b0c2001d35fb66',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '638db5e1ae6c46001be9c05d',
    firstname: null,
    lastname: null,
    teamNumber: 3,
    matchTeamId: '63d102e767b0c2001d35fb61',
    captainId: '63d0da0f96851a4d7f67e87d',
    viceCaptainId: '63d0da0f96851a4d7f67e852',
    score: 0,
    username: 'tushar92',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e863',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d102f667b0c2001d35fb67',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '638db5e1ae6c46001be9c05d',
    firstname: null,
    lastname: null,
    teamNumber: 4,
    matchTeamId: '63d102ed67b0c2001d35fb63',
    captainId: '63d0da0f96851a4d7f67e87d',
    viceCaptainId: '63d0da0f96851a4d7f67e876',
    score: 0,
    username: 'tushar92',
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e85a',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e863',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e86a',
        rating: 9,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ]
  }
];

export const pakVsNzLeaderBoardData = [
  {
    _id: '63c11d9c9dfb9f001cf6ff27',
    winning: 30000,
    rank: 1,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4929',
    firstname: 'Anmol',
    lastname: 'Kapoor',
    teamNumber: 7,
    matchTeamId: '63c054969dfb9f001cf67f9a',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f43309c',
    score: 923.5,
    verifiedScore: 923.5,
    username: 'rakeshsarkar11',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d237',
    winning: 15000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4957',
    firstname: 'Ulmuk',
    lastname: 'Chawla',
    teamNumber: 4,
    matchTeamId: '63c054969dfb9f001cf68191',
    captainId: '63be86fe0901e17d0f43309c',
    viceCaptainId: '63be86fe0901e17d0f433096',
    score: 919.5,
    verifiedScore: 919.5,
    username: 'ramvilash37',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d655',
    winning: 10000,
    rank: 3,
    tenant: 'gamio',
    userId: '623d499851b136001ebd493b',
    firstname: 'Karthika',
    lastname: '_',
    teamNumber: 9,
    matchTeamId: '63c054969dfb9f001cf68062',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f43307f',
    score: 914.5,
    verifiedScore: 914.5,
    username: 'mubarik53',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d633',
    winning: 7000,
    rank: 4,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4933',
    firstname: 'Sulabha',
    lastname: 'Mannan',
    teamNumber: 2,
    matchTeamId: '63c054969dfb9f001cf68003',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f433074',
    score: 908.5,
    verifiedScore: 908.5,
    username: 'pooranchand54',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d63a',
    winning: 5000,
    rank: 5,
    tenant: 'gamio',
    userId: '623d499851b136001ebd493d',
    firstname: 'Bharati',
    lastname: 'Goswami',
    teamNumber: 6,
    matchTeamId: '63c054969dfb9f001cf68075',
    captainId: '63be86fe0901e17d0f43309c',
    viceCaptainId: '63be86fe0901e17d0f43307f',
    score: 906.5,
    verifiedScore: 906.5,
    username: 'sarbjeetronak93',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d3f9',
    winning: 4000,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4947',
    firstname: 'Harshita',
    lastname: 'Deol',
    teamNumber: 10,
    matchTeamId: '63c054969dfb9f001cf680e7',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f43309e',
    score: 901.5,
    verifiedScore: 901.5,
    username: 'subhashchand91',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d59b',
    winning: 4000,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4932',
    firstname: 'Suniti',
    lastname: 'Haldar',
    teamNumber: 8,
    matchTeamId: '63c054969dfb9f001cf67ffe',
    captainId: '63be86fe0901e17d0f43307f',
    viceCaptainId: '63be86fe0901e17d0f433096',
    score: 901.5,
    verifiedScore: 901.5,
    username: 'lalitkathuriya10',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c11d9d9dfb9f001cf6ff2e',
    winning: 2000,
    rank: 8,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4920',
    firstname: 'Poornima',
    lastname: 'Chadha',
    teamNumber: 9,
    matchTeamId: '63c054969dfb9f001cf67f39',
    captainId: '63be86fe0901e17d0f43309c',
    viceCaptainId: '63be86fe0901e17d0f433074',
    score: 900.5,
    verifiedScore: 900.5,
    username: 'nitin46',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d63c',
    winning: 2000,
    rank: 8,
    tenant: 'gamio',
    userId: '623d499851b136001ebd493d',
    firstname: 'Bharati',
    lastname: 'Goswami',
    teamNumber: 11,
    matchTeamId: '63c054969dfb9f001cf6807a',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f433064',
    score: 900.5,
    verifiedScore: 900.5,
    username: 'sarbjeetronak93',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d4b4',
    winning: 1000,
    rank: 10,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4952',
    firstname: 'Charan',
    lastname: 'Chandra',
    teamNumber: 4,
    matchTeamId: '63c054969dfb9f001cf6815a',
    captainId: '63be86fe0901e17d0f43307f',
    viceCaptainId: '63be86fe0901e17d0f43309c',
    score: 897.5,
    verifiedScore: 897.5,
    username: 'sandeepmeghawal27',
    players: [
      {
        teamId: 13,
        role: 'wk',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43307f'
      },
      {
        teamId: 7,
        role: 'bat',
        rating: 9,
        playerId: '63be86fe0901e17d0f433064'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433096'
      },
      {
        teamId: 13,
        role: 'bat',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309a'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43306e'
      },
      {
        teamId: 7,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f433072'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309b'
      },
      {
        teamId: 13,
        role: 'all',
        rating: 8,
        playerId: '63be86fe0901e17d0f43309c'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 9,
        playerId: '63be86fe0901e17d0f433074'
      },
      {
        teamId: 7,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f433077'
      },
      {
        teamId: 13,
        role: 'bowl',
        rating: 8.5,
        playerId: '63be86fe0901e17d0f43309e'
      }
    ]
  }
];
export const indVsNzT20LeaderBoardData = [
  {
    _id: '63d11b31b5afcb001d0acfed',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '62a1f3d843d5b2001e73ad62',
    teamNumber: 1,
    matchTeamId: '63d11b27b5afcb001d0acfec',
    captainId: '63cf7a3696851a4d7f28c522',
    viceCaptainId: '63cf7a3696851a4d7f28c531',
    score: 0,
    username: 'AvDeshmukh',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c531',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c513',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52e',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c524',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c54b',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51b',
        rating: 8,
        teamId: 7,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d1fe1cb5afcb001d0ad2c8',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '6319f830168fcd001e1224b5',
    teamNumber: 1,
    matchTeamId: '63d1fe15b5afcb001d0ad2c7',
    captainId: '63cf7a3696851a4d7f28c522',
    viceCaptainId: '63cf7a3696851a4d7f28c538',
    score: 0,
    username: 'Mohdashraf',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c531',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c514',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52d',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52e',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c524',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c530',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d22f09b5afcb001d0ad447',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '62a5e85a6c3daa001e969593',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '63d22eff714ebb001dbb326d',
    captainId: '63cf7a3696851a4d7f28c538',
    viceCaptainId: '63cf7a3696851a4d7f28c530',
    score: 0,
    username: 'Guru87',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c531',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c513',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c514',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c518',
        rating: 8,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c516',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c54d',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c54c',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c530',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d22f3ab5afcb001d0ad44a',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '62a5e85a6c3daa001e969593',
    firstname: null,
    lastname: null,
    teamNumber: 2,
    matchTeamId: '63d22f34714ebb001dbb326f',
    captainId: '63cf7a3696851a4d7f28c522',
    viceCaptainId: '63cf7a3696851a4d7f28c51a',
    score: 0,
    username: 'Guru87',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c514',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52d',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c533',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c532',
        rating: 8,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c520',
        rating: 9,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c517',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c524',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d2333f714ebb001dbb32c0',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '626a926e1c2eb4001d879dc0',
    teamNumber: 1,
    matchTeamId: '63d23334b5afcb001d0ad483',
    captainId: '63cf7a3696851a4d7f28c52f',
    viceCaptainId: '63cf7a3696851a4d7f28c538',
    score: 0,
    username: 'Akrunstoppable',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c513',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c514',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52d',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c520',
        rating: 9,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c530',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c54d',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d24478714ebb001dbb3301',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '61f28983ab4e0f001f54f752',
    firstname: 'Laxman',
    lastname: 'Gole',
    teamNumber: 1,
    matchTeamId: '63d24466714ebb001dbb3300',
    captainId: '63cf7a3696851a4d7f28c538',
    viceCaptainId: '63cf7a3696851a4d7f28c530',
    score: 0,
    username: 'DEVA1989',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c513',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c537',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c517',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c524',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c530',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c54c',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d245cab5afcb001d0ad4c1',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '6287675a5dec54001dc5dbd4',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '63d245c6714ebb001dbb3306',
    captainId: '63cf7a3696851a4d7f28c52f',
    viceCaptainId: '63cf7a3696851a4d7f28c522',
    score: 0,
    username: 'CONWAY007',
    players: [
      {
        playerId: '63cf7a3696851a4d7f28c522',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c531',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a3696851a4d7f28c513',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52c',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c538',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52f',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c51a',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c516',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a3696851a4d7f28c52e',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c524',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a3696851a4d7f28c530',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      }
    ]
  }
];
export const indVsSlTestLeaderBoardData = [
  {
    _id: '622c3d26ff867e001dbb43b7',
    winning: 3000,
    rank: 1,
    tenant: 'dev',
    userId: '5fd092b96d6b034a40160a7d',
    firstname: 'Manoj',
    lastname: 'Bisht',
    teamNumber: 2,
    matchTeamId: '622c3ca8ff867e001dbb43a9',
    captainId: '6225784a17d940379f6d6adf',
    viceCaptainId: '6225784a17d940379f6d6a7c',
    score: 964,
    verifiedScore: 964,
    username: 'AFLATOON',
    players: [
      {
        playerId: '6225784a17d940379f6d6ab8',
        rating: 9,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6ac2',
        rating: 10,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a79',
        rating: 9.5,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a7c',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6adf',
        rating: 9.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6a92',
        rating: 9,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6225eae917d940379f82819a',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6aef',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa9',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aad',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa4',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '622c3d26ff867e001dbb43b6',
    winning: 2000,
    rank: 2,
    tenant: 'dev',
    userId: '5fd092b96d6b034a40160a7d',
    firstname: 'Manoj',
    lastname: 'Bisht',
    teamNumber: 1,
    matchTeamId: '622c3c84ff867e001dbb43a1',
    captainId: '6225784a17d940379f6d6a7c',
    viceCaptainId: '6225784a17d940379f6d6a92',
    score: 869.5,
    verifiedScore: 869.5,
    username: 'AFLATOON',
    players: [
      {
        playerId: '6225784a17d940379f6d6ab8',
        rating: 9,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6ac2',
        rating: 10,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a79',
        rating: 9.5,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a7c',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6adf',
        rating: 9.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6a92',
        rating: 9,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6225eae917d940379f82819a',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6aef',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa9',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aad',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa4',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '6229cef72527e9001f0ccdcb',
    winning: 1000,
    rank: 3,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Verma',
    teamNumber: 1,
    matchTeamId: '6229cc2b2527e9001f0ccdb3',
    captainId: '6225784a17d940379f6d6a77',
    viceCaptainId: '6225784a17d940379f6d6a74',
    score: 831,
    verifiedScore: 831,
    username: 'Kamal',
    players: [
      {
        playerId: '6225784a17d940379f6d6ab8',
        rating: 9,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6a77',
        rating: 8.5,
        teamId: 21,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6a74',
        rating: 8.5,
        teamId: 21,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6ac2',
        rating: 10,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a79',
        rating: 9.5,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6ac5',
        rating: 9.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a7c',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a8d',
        rating: 9,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6aef',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa9',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aad',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ]
  }
];
export const indVsSaT20LeaderBoardData = [
  {
    _id: '63390fb329a44d001d391c97',
    winning: 30000,
    rank: 1,
    tenant: 'gamio',
    userId: '63344b2c69b991001fa16e88',
    teamNumber: 6,
    matchTeamId: '63390b0d29a44d001d391c5b',
    captainId: '63345055258445b807483a35',
    viceCaptainId: '63345055258445b807483a4f',
    score: 883,
    verifiedScore: 883,
    username: '63344b2c69b991001fa16e87',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a59'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 9,
        playerId: '63345055258445b807483a49'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a7f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '6339873d2dcd02001dbafcbd',
    winning: 15000,
    rank: 2,
    tenant: 'gamio',
    userId: '6184ed82351c65001fa3381a',
    firstname: 'Rashid',
    lastname: 'Siddiqui',
    teamNumber: 1,
    matchTeamId: '633987362dcd02001dbafcb9',
    captainId: '63345055258445b807483a66',
    viceCaptainId: '63345055258445b807483a32',
    score: 859,
    verifiedScore: 859,
    username: 'Rashidali',
    players: [
      {
        playerId: '63345055258445b807483a32',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a5e',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a35',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a40',
        rating: 9,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a73',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a49',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a4f',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a7f',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a82',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63393e1629a44d001d391e52',
    winning: 10000,
    rank: 3,
    tenant: 'gamio',
    userId: '632f288c1c4ee5001e135dc0',
    teamNumber: 1,
    matchTeamId: '63393e0b29a44d001d391e51',
    captainId: '63345055258445b807483a60',
    viceCaptainId: '63345055258445b807483a40',
    score: 844.5,
    verifiedScore: 844.5,
    username: '632f288c1c4ee5001e135dbf',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a66'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 9,
        playerId: '63345055258445b807483a49'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a7f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '633991e329a44d001d392c6e',
    winning: 7000,
    rank: 4,
    tenant: 'gamio',
    userId: '61e408c0d26163001e5ef8d0',
    firstname: 'Satish',
    lastname: 'Kumar',
    teamNumber: 1,
    matchTeamId: '633965eb69b991001fa1a528',
    captainId: '63345055258445b807483a73',
    viceCaptainId: '63345055258445b807483a66',
    score: 841,
    verifiedScore: 841,
    username: 'KumarSatish',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a59'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a66'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4d'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '6338fe1029a44d001d391bef',
    winning: 5000,
    rank: 5,
    tenant: 'gamio',
    userId: '624d873efe476e001f4cc0b4',
    teamNumber: 2,
    matchTeamId: '6338fd9669b991001fa19fa4',
    captainId: '63345055258445b807483a66',
    viceCaptainId: '63345055258445b807483a40',
    score: 832.5,
    verifiedScore: 832.5,
    username: '624d873efe476e001f4cc0b3',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a59'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a66'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4d'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a7f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '6339920f69b991001fa1aff3',
    winning: 4500,
    rank: 6,
    tenant: 'gamio',
    userId: '623eda437e6c08001f00cf8f',
    firstname: 'AKASH',
    lastname: 'MANDALE',
    teamNumber: 1,
    matchTeamId: '6339920529a44d001d392cbe',
    captainId: '63345055258445b807483a66',
    viceCaptainId: '63345055258445b807483a73',
    score: 821.5,
    verifiedScore: 821.5,
    username: '4995sai',
    players: [
      {
        playerId: '63345055258445b807483a32',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a59',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a5e',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a35',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a40',
        rating: 9,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a73',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a49',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a7f',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a82',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '6337dc352dcd02001dbae61a',
    winning: 3500,
    rank: 7,
    tenant: 'gamio',
    userId: '6249327339afa1001f010882',
    firstname: 'kush',
    lastname: 'Kumar',
    teamNumber: 2,
    matchTeamId: '6337dc2869b991001fa1932d',
    captainId: '63345055258445b807483a66',
    viceCaptainId: '63345055258445b807483a35',
    score: 798,
    verifiedScore: 798,
    username: 'Kkplayer',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a3e'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a66'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 8,
        playerId: '63345055258445b807483a46'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 9,
        playerId: '63345055258445b807483a49'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a7f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '63398ebb29a44d001d392851',
    winning: 2500,
    rank: 8,
    tenant: 'gamio',
    userId: '6284ae0d56e08a001d469301',
    teamNumber: 2,
    matchTeamId: '63398e8569b991001fa1ab37',
    captainId: '63345055258445b807483a60',
    viceCaptainId: '63345055258445b807483a32',
    score: 797,
    verifiedScore: 797,
    username: 'bajkoti',
    players: [
      {
        playerId: '63345055258445b807483a32',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a5e',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a35',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a40',
        rating: 9,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a73',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a46',
        rating: 8,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a49',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a7f',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a82',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '6337dbd729a44d001d390f22',
    winning: 1500,
    rank: 9,
    tenant: 'gamio',
    userId: '6249327339afa1001f010882',
    firstname: 'kush',
    lastname: 'Kumar',
    teamNumber: 1,
    matchTeamId: '6337dbd02dcd02001dbae611',
    captainId: '63345055258445b807483a60',
    viceCaptainId: '63345055258445b807483a5e',
    score: 796,
    verifiedScore: 796,
    username: 'Kkplayer',
    players: [
      {
        playerId: '63345055258445b807483a32',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a57',
        rating: 8,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a5e',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a35',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a40',
        rating: 9,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a73',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a49',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a4f',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a7d',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63398e7c69b991001fa1ab31',
    winning: 1000,
    rank: 10,
    tenant: 'gamio',
    userId: '62a1f3d843d5b2001e73ad62',
    teamNumber: 2,
    matchTeamId: '63398e7229a44d001d3927ff',
    captainId: '63345055258445b807483a59',
    viceCaptainId: '63345055258445b807483a66',
    score: 788,
    verifiedScore: 788,
    username: 'AvDeshmukh',
    players: [
      {
        playerId: '63345055258445b807483a32',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a57',
        rating: 8,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a59',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a5e',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a35',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a46',
        rating: 8,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a4d',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a4f',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a82',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '6339913269b991001fa1ae87',
    winning: 500,
    rank: 11,
    tenant: 'gamio',
    userId: '61fbc8d669e5ee001d175e72',
    firstname: null,
    lastname: null,
    teamNumber: 2,
    matchTeamId: '6339908d69b991001fa1addd',
    captainId: '63345055258445b807483a60',
    viceCaptainId: '63345055258445b807483a35',
    score: 783,
    verifiedScore: 783,
    username: 'Sk58',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a59'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a3c'
      },
      {
        teamId: 19,
        role: 'all',
        rating: 9,
        playerId: '63345055258445b807483a40'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 9,
        playerId: '63345055258445b807483a49'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4d'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  },
  {
    _id: '6339885d29a44d001d392628',
    winning: 500,
    rank: 12,
    tenant: 'gamio',
    userId: '631b3ffe168fcd001e123170',
    teamNumber: 3,
    matchTeamId: '633988152dcd02001dbafccc',
    captainId: '63345055258445b807483a32',
    viceCaptainId: '63345055258445b807483a49',
    score: 780,
    verifiedScore: 780,
    username: '631b3ffe168fcd001e12316f',
    players: [
      {
        teamId: 19,
        role: 'wk',
        rating: 9,
        playerId: '63345055258445b807483a32'
      },
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '63345055258445b807483a54'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '63345055258445b807483a5e'
      },
      {
        teamId: 19,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a35'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8.5,
        playerId: '63345055258445b807483a60'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 8,
        playerId: '63345055258445b807483a66'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 8.5,
        playerId: '63345055258445b807483a73'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 9,
        playerId: '63345055258445b807483a49'
      },
      {
        teamId: 19,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a4f'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a7d'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8,
        playerId: '63345055258445b807483a82'
      }
    ]
  }
];
export const slVsAfgT20LeaderBoardData = [
  {
    _id: '630a20cee37e36001f6f70c0',
    winning: 400000,
    rank: 1,
    tenant: 'gamio',
    userId: '6171625f2dc7d4001cc10ed1',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '630a20bc102dac0020fbbede',
    captainId: '6307271c7e2d41535f39f809',
    viceCaptainId: '6307271c7e2d41535f39f7f3',
    score: 708,
    verifiedScore: 708,
    username: 'Gpsport',
    players: [
      {
        playerId: '6307271c7e2d41535f39f7c2',
        rating: 9,
        teamId: 498,
        role: 'wk'
      },
      {
        playerId: '6307271c7e2d41535f39f7d3',
        rating: 9,
        teamId: 498,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f789',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f78a',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f794',
        rating: 9.5,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7e3',
        rating: 9,
        teamId: 498,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7ef',
        rating: 9.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f3',
        rating: 9,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f6',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f809',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7b7',
        rating: 8,
        teamId: 21,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '630a22c7102dac0020fbc23c',
    winning: 200000,
    rank: 2,
    tenant: 'gamio',
    userId: '614b0f29c6c4c7001ee5dd86',
    firstname: 'Dalip',
    lastname: 'Singh',
    teamNumber: 11,
    matchTeamId: '630a22bf102dac0020fbc227',
    captainId: '6307271c7e2d41535f39f809',
    viceCaptainId: '6307271c7e2d41535f39f79e',
    score: 675,
    verifiedScore: 675,
    username: 'Dsghi',
    players: [
      {
        playerId: '6307271c7e2d41535f39f7c2',
        rating: 9,
        teamId: 498,
        role: 'wk'
      },
      {
        playerId: '6307271c7e2d41535f39f786',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f7d3',
        rating: 9,
        teamId: 498,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f78a',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f794',
        rating: 9.5,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7e3',
        rating: 9,
        teamId: 498,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f79e',
        rating: 8.5,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7ef',
        rating: 9.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f3',
        rating: 9,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f809',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7a6',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '630a21ba102dac0020fbc010',
    winning: 100000,
    rank: 3,
    tenant: 'gamio',
    userId: '6242d96277d389001d964bcd',
    firstname: null,
    lastname: null,
    teamNumber: 4,
    matchTeamId: '6309bfc88affc500207ae2dd',
    captainId: '6307271c7e2d41535f39f809',
    viceCaptainId: '6307271c7e2d41535f39f7c2',
    score: 668.5,
    verifiedScore: 668.5,
    username: 'IGAMIODREAM11',
    players: [
      {
        teamId: 498,
        role: 'wk',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7c2'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f786'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f789'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f78a'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7e3'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7e5'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f79e'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f7ef'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7f3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f809'
      },
      {
        teamId: 21,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7a6'
      }
    ]
  },
  {
    _id: '630a1e90e37e36001f6f6ead',
    winning: 50000,
    rank: 4,
    tenant: 'gamio',
    userId: '61bd2d7fb25294001db492e2',
    firstname: 'Pappu',
    lastname: 'Kumar',
    teamNumber: 3,
    matchTeamId: '630a1e6f8affc500207aeb29',
    captainId: '6307271c7e2d41535f39f809',
    viceCaptainId: '6307271c7e2d41535f39f794',
    score: 662.5,
    verifiedScore: 662.5,
    username: 'Pappurajak',
    players: [
      {
        teamId: 498,
        role: 'wk',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7c2'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f786'
      },
      {
        teamId: 498,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7d3'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f789'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f794'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7e3'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7e5'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7e9'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7f6'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f809'
      },
      {
        teamId: 21,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7a6'
      }
    ]
  },
  {
    _id: '630a1fffe37e36001f6f6fc6',
    winning: 50000,
    rank: 5,
    tenant: 'gamio',
    userId: '615309496c52f4001e2e1c57',
    firstname: 'Navrtan',
    lastname: 'Lal',
    teamNumber: 6,
    matchTeamId: '630a1fdf102dac0020fbbdaf',
    captainId: '6307271c7e2d41535f39f7c2',
    viceCaptainId: '6307271c7e2d41535f39f794',
    score: 659.5,
    verifiedScore: 659.5,
    username: 'Navratanlal',
    players: [
      {
        playerId: '6307271c7e2d41535f39f7c2',
        rating: 9,
        teamId: 498,
        role: 'wk'
      },
      {
        playerId: '6307271c7e2d41535f39f786',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f7d3',
        rating: 9,
        teamId: 498,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f789',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f78a',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f794',
        rating: 9.5,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7e3',
        rating: 9,
        teamId: 498,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7f3',
        rating: 9,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f6',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f809',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7a6',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '630a20908affc500207aecf1',
    winning: 50000,
    rank: 6,
    tenant: 'gamio',
    userId: '619655dfb20e43001efaabec',
    firstname: 'Amiya',
    lastname: 'Mandal',
    teamNumber: 3,
    matchTeamId: '6309ccf5e37e36001f6f67df',
    captainId: '6307271c7e2d41535f39f7c2',
    viceCaptainId: '6307271c7e2d41535f39f7e3',
    score: 659,
    verifiedScore: 659,
    username: 'Amiya243',
    players: [
      {
        teamId: 498,
        role: 'wk',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7c2'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f786'
      },
      {
        teamId: 498,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7d3'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f78a'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f794'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7e3'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f79e'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f7ef'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7f3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7f6'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f809'
      }
    ]
  },
  {
    _id: '630a20158affc500207aec3a',
    winning: 24000,
    rank: 7,
    tenant: 'gamio',
    userId: '617584f92dc7d4001cc15cd4',
    firstname: 'Anis',
    lastname: 'Mujawar',
    teamNumber: 8,
    matchTeamId: '6309d87de37e36001f6f69ef',
    captainId: '6307271c7e2d41535f39f809',
    viceCaptainId: '6307271c7e2d41535f39f7f3',
    score: 657,
    verifiedScore: 657,
    username: 'Anismujawar',
    players: [
      {
        teamId: 498,
        role: 'wk',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7c2'
      },
      {
        teamId: 21,
        role: 'wk',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f784'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f786'
      },
      {
        teamId: 498,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7d3'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f789'
      },
      {
        teamId: 498,
        role: 'bat',
        rating: 8,
        playerId: '6307271c7e2d41535f39f7df'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f798'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7e3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f7ef'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7f3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f809'
      }
    ]
  },
  {
    _id: '6309dcede37e36001f6f6a24',
    winning: 24000,
    rank: 8,
    tenant: 'gamio',
    userId: '62f3de86f06510001de35d13',
    teamNumber: 3,
    matchTeamId: '6309dc75102dac0020fbb837',
    captainId: '6307271c7e2d41535f39f794',
    viceCaptainId: '6307271c7e2d41535f39f809',
    score: 646.5,
    verifiedScore: 646.5,
    username: '62f3de86f06510001de35d12',
    players: [
      {
        teamId: 498,
        role: 'wk',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7c2'
      },
      {
        teamId: 498,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7d3'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f789'
      },
      {
        teamId: 21,
        role: 'bat',
        rating: 9,
        playerId: '6307271c7e2d41535f39f78a'
      },
      {
        teamId: 21,
        role: 'all',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f794'
      },
      {
        teamId: 498,
        role: 'all',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7e3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9.5,
        playerId: '6307271c7e2d41535f39f7ef'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 9,
        playerId: '6307271c7e2d41535f39f7f3'
      },
      {
        teamId: 498,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f809'
      },
      {
        teamId: 21,
        role: 'bowl',
        rating: 8.5,
        playerId: '6307271c7e2d41535f39f7a6'
      },
      {
        teamId: 21,
        role: 'bowl',
        rating: 8,
        playerId: '6307271c7e2d41535f39f7bb'
      }
    ]
  }
];

export const indVsZimLeaderBoardData = [
  {
    _id: '63003754405a94001d2083a8',
    winning: 500000,
    rank: 1,
    tenant: 'gamio',
    userId: '62ef5738c52f1a001eb60c44',
    teamNumber: 2,
    matchTeamId: '6300370ad344d0001f309131',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 725.5,
    verifiedScore: 725.5,
    username: '62ef5738c52f1a001eb60c43',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9.5,
        playerId: '62fdf27a1f7aacc4e3533189'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9.5,
        playerId: '62fdf27a1f7aacc4e3533218'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e35331a0'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e35331b2'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      }
    ]
  },
  {
    _id: '63008795db79c0002171b963',
    winning: 115000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd49d1',
    firstname: 'Kripa',
    lastname: '_',
    teamNumber: 8,
    matchTeamId: '62ffc942db79c00021715ab3',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 720.5,
    verifiedScore: 720.5,
    username: 'gutam4',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '62ffc984db79c00021716edf',
    winning: 115000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd494d',
    firstname: 'Purav',
    lastname: 'Mannan',
    teamNumber: 1,
    matchTeamId: '62ffc944db79c000217167e8',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 720.5,
    verifiedScore: 720.5,
    username: 'arunvicky33',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '6300869edb79c0002171ada4',
    winning: 115000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd48d5',
    firstname: 'Unnatish',
    lastname: 'Kapoor',
    teamNumber: 3,
    matchTeamId: '62ffc943db79c00021715e13',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 720.5,
    verifiedScore: 720.5,
    username: 'sevakpitambarlal69',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '63007fa0db79c00021719878',
    winning: 115000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4a24',
    firstname: 'Subeer',
    lastname: 'Chabra',
    teamNumber: 5,
    matchTeamId: '62ffc943db79c000217162fb',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 720.5,
    verifiedScore: 720.5,
    username: 'ramesh37',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '62ffc984db79c00021716d8c',
    winning: 43675,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4933',
    firstname: 'Sulabha',
    lastname: 'Mannan',
    teamNumber: 4,
    matchTeamId: '62ffc944db79c000217166cd',
    captainId: '62fdf27a1f7aacc4e35331bf',
    viceCaptainId: '62fdf27a1f7aacc4e353317f',
    score: 717,
    verifiedScore: 717,
    username: 'pooranchand54',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '63007fa0db79c00021719794',
    winning: 43675,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4a21',
    firstname: 'Aaryahi',
    lastname: '_',
    teamNumber: 11,
    matchTeamId: '62ffc943db79c000217162e0',
    captainId: '62fdf27a1f7aacc4e35331bf',
    viceCaptainId: '62fdf27a1f7aacc4e353317f',
    score: 717,
    verifiedScore: 717,
    username: 'deelip34',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '63008795db79c0002171b846',
    winning: 43675,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd49ac',
    firstname: 'Vadin',
    lastname: 'Pandey',
    teamNumber: 11,
    matchTeamId: '62ffc942db79c0002171591f',
    captainId: '62fdf27a1f7aacc4e35331bf',
    viceCaptainId: '62fdf27a1f7aacc4e353317f',
    score: 717,
    verifiedScore: 717,
    username: 'nikhil98',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '6300869edb79c0002171ae63',
    winning: 43675,
    rank: 6,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4916',
    firstname: 'Sarish',
    lastname: 'Malhotra',
    teamNumber: 3,
    matchTeamId: '62ffc943db79c000217160d3',
    captainId: '62fdf27a1f7aacc4e35331bf',
    viceCaptainId: '62fdf27a1f7aacc4e353317f',
    score: 717,
    verifiedScore: 717,
    username: 'pulkitsharma7',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  },
  {
    _id: '63007fa0db79c00021719a1c',
    winning: 20625,
    rank: 10,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4a5d',
    firstname: 'Supriti',
    lastname: '_',
    teamNumber: 11,
    matchTeamId: '62ffc943db79c00021716574',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e353323a',
    score: 711.5,
    verifiedScore: 711.5,
    username: 'pappumahendersingh23',
    players: [
      {
        teamId: 25,
        role: 'wk',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353317f'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331fd'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e353323a'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533257'
      },
      {
        teamId: 493,
        role: 'bowl',
        rating: 8,
        playerId: '62fdf27a1f7aacc4e3533248'
      }
    ]
  }
];
export const engWVsAusWU19LeaderBoardData = [
  {
    _id: '63d28a47b5afcb001d0ad657',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    teamNumber: 1,
    matchTeamId: '63d28a42714ebb001dbb34ce',
    captainId: '63d1675696851a4d7f805b98',
    viceCaptainId: '63d1675696851a4d7f805b7f',
    score: 0,
    username: 'RajasthanRoyals',
    players: [
      {
        playerId: '63d1675696851a4d7f805ba2',
        rating: 8.5,
        teamId: 127123,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b8b',
        rating: 8.5,
        teamId: 127109,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b81',
        rating: 9,
        teamId: 127109,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b97',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b9a',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b98',
        rating: 9,
        teamId: 127123,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b7f',
        rating: 9,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b80',
        rating: 8.5,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b9c',
        rating: 8.5,
        teamId: 127123,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805b85',
        rating: 8.5,
        teamId: 127109,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805ba5',
        rating: 8.5,
        teamId: 127123,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d28b40714ebb001dbb34d1',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    teamNumber: 2,
    matchTeamId: '63d28b3b714ebb001dbb34d0',
    captainId: '63d1675696851a4d7f805b9a',
    viceCaptainId: '63d1675696851a4d7f805b83',
    score: 0,
    username: 'RajasthanRoyals',
    players: [
      {
        playerId: '63d1675696851a4d7f805b8b',
        rating: 8.5,
        teamId: 127109,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b89',
        rating: 8,
        teamId: 127109,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b97',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b9a',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b83',
        rating: 8.5,
        teamId: 127109,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b8c',
        rating: 8.5,
        teamId: 127109,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b7f',
        rating: 9,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b80',
        rating: 8.5,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805ba5',
        rating: 8.5,
        teamId: 127123,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805b91',
        rating: 8.5,
        teamId: 127109,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805b9f',
        rating: 8,
        teamId: 127123,
        role: 'bowl'
      }
    ]
  }
];
export const wiWVsIndWLeaderBoardData = [
  {
    _id: '63d290e767b0c2001d35fc28',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d2687167b0c2001d35fc24',
    captainId: '63cc01c296851a4d7f92ea4a',
    viceCaptainId: '63cc01c296851a4d7f92ea3b',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cc01c296851a4d7f92ea4a',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea3b',
        rating: 8,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea37',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea38',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea59',
        rating: 8.5,
        teamId: 10272,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea42',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea41',
        rating: 8.5,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea45',
        rating: 8.5,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea55',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5f',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea65',
        rating: 8,
        teamId: 10272,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d2910367b0c2001d35fc2d',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '63d290fe67b0c2001d35fc2c',
    captainId: '63cc01c296851a4d7f92ea5b',
    viceCaptainId: '63cc01c296851a4d7f92ea60',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cc01c296851a4d7f92ea4a',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea3b',
        rating: 8,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea59',
        rating: 8.5,
        teamId: 10272,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea42',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5b',
        rating: 8,
        teamId: 10272,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea60',
        rating: 8,
        teamId: 10272,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5a',
        rating: 8,
        teamId: 10272,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5e',
        rating: 8,
        teamId: 10272,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea48',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea55',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5f',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      }
    ]
  }
];
export const saWVsIndWLeaderBoardData = [
  {
    _id: '63d2aaf567b0c2001d35fc72',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d2aaf067b0c2001d35fc71',
    captainId: '63cbff6996851a4d7f9285b1',
    viceCaptainId: '63cbff6996851a4d7f9285d6',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cbff6996851a4d7f9285c2',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285ef',
        rating: 8.5,
        teamId: 10279,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285af',
        rating: 8,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285fa',
        rating: 8,
        teamId: 10279,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285a9',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285aa',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285d6',
        rating: 8.5,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285b1',
        rating: 9,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cbff6996851a4d7f9285ac',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285bf',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285da',
        rating: 8.5,
        teamId: 10279,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d2ab1e67b0c2001d35fc77',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '63d2ab1967b0c2001d35fc76',
    captainId: '63cbff6996851a4d7f9285b1',
    viceCaptainId: '63cbff6996851a4d7f9285fd',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cbff6996851a4d7f9285c2',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285aa',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285e6',
        rating: 9,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285d6',
        rating: 8.5,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285b6',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285c9',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285fd',
        rating: 8,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285b1',
        rating: 9,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cbff6996851a4d7f9285ac',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285bf',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285da',
        rating: 8.5,
        teamId: 10279,
        role: 'bowl'
      }
    ]
  }
];
export const indWVsNzWU19LeaderBoardData = [
  {
    _id: '63d2acce67b0c2001d35fc7c',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d2accb67b0c2001d35fc7b',
    captainId: '63d1796f96851a4d7f832aec',
    viceCaptainId: '63d1796f96851a4d7f832b22',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63d1796f96851a4d7f832b18',
        rating: 9,
        teamId: 126969,
        role: 'wk'
      },
      {
        playerId: '63d1796f96851a4d7f832af1',
        rating: 8.5,
        teamId: 126918,
        role: 'wk'
      },
      {
        playerId: '63d1796f96851a4d7f832b0b',
        rating: 8.5,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832aec',
        rating: 8.5,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b22',
        rating: 8.5,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b3e',
        rating: 8.5,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b4c',
        rating: 8.5,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832afa',
        rating: 9,
        teamId: 126918,
        role: 'all'
      },
      {
        playerId: '63d1796f96851a4d7f832af4',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b10',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b27',
        rating: 8.5,
        teamId: 126969,
        role: 'bowl'
      }
    ]
  },
  {
    _id: '63d2ace467b0c2001d35fc81',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '63d2ace067b0c2001d35fc80',
    captainId: '63d1796f96851a4d7f832b22',
    viceCaptainId: '63d1796f96851a4d7f832afd',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63d1796f96851a4d7f832af1',
        rating: 8.5,
        teamId: 126918,
        role: 'wk'
      },
      {
        playerId: '63d1796f96851a4d7f832aec',
        rating: 8.5,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b22',
        rating: 8.5,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832afd',
        rating: 8,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b0a',
        rating: 8,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b1f',
        rating: 8,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b05',
        rating: 9,
        teamId: 126918,
        role: 'all'
      },
      {
        playerId: '63d1796f96851a4d7f832af4',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b10',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b27',
        rating: 8.5,
        teamId: 126969,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b28',
        rating: 8.5,
        teamId: 126969,
        role: 'bowl'
      }
    ]
  }
];
